import { del, get, post, put } from "../../services/ApiRouting";

// Function to fetch all products
export async function getAllProducts() {
  const response = await get(`${API_URL}/crud/products?filter=all`);
  return response.data;
}

// Function to create a new project
export async function createProduct(projectData) {
  try {
    const response = await post(`${API_URL}/crud/products`, projectData);
    return response;
  } catch (error) {
    console.error("Error creating project:", error);
    throw error.response ? error.response.data : new Error("Network Error");
  }
}
// Function to fetch a single project by ID
export async function getProductById(token, projectId) {
  const response = await axios.get(`${API_URL}/crud/products/${projectId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.data;
}

// Function to update an existing project
export async function updateProduct(projectId, projectData) {
  const response = await put(
    `${API_URL}/crud/products/${projectId}`,
    projectData
  );
  return response;
}

// Function to delete a project
export async function deleteProduct(projectId) {
  const response = await del(`${API_URL}/crud/products/${projectId}`);
  return response.data;
}
